import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

import scrollToComponent from 'react-scroll-to-component';

import * as locations from '../../../constants/dropdown';

import {messageTextValidation, nameValidation, emailValidation, phoneValidation, locationValidation} from '../../../utils/itemValidation';

import RhinoSelect from '../../common/inputs/RhinoSelect';
import {ScheduleShoppingFormContainer} from '../scheduleappointment/components/ScheduleShoppingForm';
import {ScheduleServiceFormContainer} from '../scheduleappointment/components/ScheduleServiceForm';

import * as commonActionCreators from '../../../actions/common';
let allActionCreators = Object.assign({}, commonActionCreators);

class ContactPage extends React.Component {

  static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: React.PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);

    const firstEntry = [{display: 'Location*', 'value': ''}];
    const finalEntry = [{display: 'Virtual/Other', 'value': 'online@diamondsdirect.com'}];

    let newArray= firstEntry.concat(locations.locations).concat(finalEntry);

    this.state = {
      
      selectedOption: null,
      selectedForm: null, 

      locations: newArray,

      inputName: '',
      inputEmail: '',
      inputPhone: '',
      inputLocation: '',
      inputMessage: '',

      errorName: null,
      errorEmail: null,
      errorPhone: null,
      errorLocation: null,
      errorMessage: null,

      formOpen: false,
    };
  }

  componentDidMount() {
    document.title = 'Diamonds Direct - Contact Us';
    document.getElementsByTagName("META")[7].content="Shop our extensive selection of diamond engagement rings, wedding bands, and other jewelry online. See the Diamonds Direct Difference today!";
  }

  newTabNav(page) {
    let win = window.open(page, '_blank');
    win.focus();
  }

  externalNav(page) {
    window.location.href = '/' + page;
  }

  internalNav(page) {
    this.context.router.push('/' + page);
  }

  openIntercom() {
    // window.Intercom('show');
    acquireIO.max();
  }


  changeName(evt) {
    this.setState({ inputName: evt.target.value }, () => {
      if(this.state.errorName && !nameValidation(this.state.inputName)) {
        this.setState({ errorName: null });
      }
    });
  }

  changeEmail(evt) {
    this.setState({ inputEmail: evt.target.value }, () => {
      if(this.state.errorEmail && !emailValidation(this.state.inputEmail)) {
        this.setState({ errorEmail: null });
      }
    });
  }

  changePhone(evt) {
    this.setState({ inputPhone: evt.target.value }, () => {
      if(this.state.errorPhone && !phoneValidation(this.state.inputPhone)) {
        this.setState({ errorPhone: null });
      }
    });
  }

  changeLocation(evt) {
    this.setState({inputLocation: evt.target.value}, () => {
      if(this.state.errorLocation !== false && location !== '') {
        this.setState({errorLocation: null});
      }
    });
  }  

  changeMessage(evt) {
    this.setState({ inputMessage: evt.target.value }, () => {
      if(this.state.errorMessage && !messageTextValidation(this.state.inputMessage)) {
        this.setState({ errorMessage: null });
      }
    });
  }

  validateAll() {
    let hasErrors = true;
    
    // Required params
    let nameError = nameValidation(this.state.inputName);
    let emailError = emailValidation(this.state.inputEmail);
    let messageError = messageTextValidation(this.state.inputMessage);
    let locationError = locationValidation(this.state.inputLocation);

    // Optional params
    let phoneError = null;
    if(this.state.inputPhone) {
      phoneError = phoneValidation(this.state.inputPhone);
    }

    if(nameError === null &&
       emailError === null &&
       phoneError === null &&
       locationError === null &&
       messageError === null) {
      hasErrors = false;
    }

    this.setState({
      errorName: nameError,
      errorEmail: emailError,
      errorPhone: phoneError,
      errorLocation: locationError,
      errorMessage: messageError
    });

    return !hasErrors;
  }

  submitContactRequest() {
    if(this.validateAll()) {

      let contactData = {
        full_name: this.state.inputName,
        email: this.state.inputEmail,
        phone: this.state.inputPhone,
        location: this.state.inputLocation,
        message: this.state.inputMessage,
      }

      this.props.commonContactRequest(contactData)
      .then(() => {
        this.context.router.push('/thank-you');
        // this.props.commonAlert('Thank you for submitting a request! A member of our team will follow up with you shortly to finalize your virtual appointment.', 'Continue Browsing', 'helping', '');
      });
      this.setState({
        inputName: '',
        inputEmail: '',
        inputPhone: '',
        inputLocation: '',
        inputMessage: '',
        errorName: null,
        errorEmail: null,
        errorPhone: null,
        errorLocation: null,
        errorMessage: null,
      });
      this.props.commonCloseContact();
    }
  }

  toggleFormOpen() {
    this.setState({ formOpen: !this.state.formOpen });
  }

  toggleOption(optionValue) {
    if(!optionValue) {
      return;
    }

    if(optionValue === this.state.selectedOption) {
      this.setState({ selectedOption: null, selectedForm: null });
    } else {
      this.setState({ selectedOption: optionValue, selectedForm: null });
    }
  }

  toggleForm(formValue) {
    if(!formValue) {
      return;
    }

    if(formValue === this.state.selectedForm) {
      this.setState({ selectedForm: null });
    } else {
      this.setState({ selectedForm: formValue }, () => {
        this.scrollToForm();
      });
    }
  }

  scrollToForm() {
    scrollToComponent(this.formWrapper, {
      offset: -100, 
      align: 'top', 
      duration: 750, 
      ease: 'inOutCube',
    });
  }

  render() {
    return <div className='ContactPage' ref={(div) => { this.parentForm = div; }}>
      <div className='scheduleHeader'>Connect with an Expert</div>
      <div className='scheduleLeftBg'></div>
      <div className='scheduleRightBg'></div>
      <div className='scheduleBody'>
        <div className='scheduleBr'></div>
        <div className={'sbText'}>Now more than ever before, we are focused on customizing the Diamonds Direct experience.</div>
        <div className='optionsWrapper'>
          <div className='singleOption'>
            <div className={this.state.selectedOption === 'online' ? 'optionItem selected' : 'optionItem'} onClick={() => this.toggleOption('online')}>
              <div className='optionImg'>
                <img src='https://ddw2.diamondsdirect.com/img/contact/chat.svg' />
              </div>
              <div className='optionBr'></div>
              <div className='optionTitle'>
                <div>Connect with an expert<br />ONLINE</div>
              </div>
              <div className='optionButton' onClick={::this.openIntercom}>Chat Now</div>
            </div>
            <div className={this.state.selectedOption === 'online' ? 'optionRow open' : 'optionRow'}>
              <div className='optionRowButton' onClick={::this.openIntercom}>Live Chat with an Expert</div>
              <div className='optionRowButton' onClick={() => this.internalNav('video-chat')}>Live Video with an Expert</div>
            </div>
            <div className='optionFormMobile'></div>
          </div>
          <div className='singleOption'>
            <div className={this.state.selectedOption === 'store' ? 'optionItem selected' : 'optionItem'} onClick={() => this.toggleOption('store')}>
              <div className='optionImg'>
                <img src='https://ddw2.diamondsdirect.com/img/contact/video.svg' />
              </div>
              <div className='optionBr'></div>
              <div className='optionTitle'>
                <div>Connect with an expert<br />IN STORE</div>
              </div>
              <div className='optionButton' onClick={() => this.internalNav('video-chat')}>Video Chat Now</div>
            </div>
            <div className={this.state.selectedOption === 'store' ? 'optionRow open' : 'optionRow'}>
              <div className={this.state.selectedForm === 'store' ? 'optionRowButton selected' : 'optionRowButton'} onClick={() => this.toggleForm('store')}>Contact a Store</div>
              <div className={this.state.selectedForm === 'shopping' ? 'optionRowButton selected' : 'optionRowButton'} onClick={() => this.toggleForm('shopping')}>Request an Appointment</div>
            </div>
            <div className='optionFormMobile'></div>
          </div>
          <div className='singleOption'>
            <div className={this.state.selectedOption === 'service' ? 'optionItem selected' : 'optionItem'} onClick={() => this.toggleOption('service')}>
              <div className='optionImg'>
                <img src='https://ddw2.diamondsdirect.com/img/contact/appt.svg' />
              </div>
              <div className='optionBr'></div>
              <div className='optionTitle'>
                <div>SERVICE &amp;<br />REPAIRS</div>
              </div>
              <div className={this.state.formOpen ? 'optionButton selected' : 'optionButton'} onClick={::this.toggleFormOpen}>Request Appointment</div>
            </div>
            <div className={this.state.selectedOption === 'service' ? 'optionRow open' : 'optionRow'}>
              <div className={this.state.selectedForm === 'store' ? 'optionRowButton selected' : 'optionRowButton'} onClick={() => this.toggleForm('store')}>Contact a Store</div>
              <div className={this.state.selectedForm === 'service' ? 'optionRowButton selected' : 'optionRowButton'} onClick={() => this.toggleForm('service')}>Request an Appointment</div>
            </div>
            <div className='optionFormMobile'></div>
          </div>
        </div>
        <div className={this.state.selectedForm === 'store' ? 'sbFormWrapper openForm' : 'sbFormWrapper'} ref={(div) => { this.formWrapper = div; }}>
          <div className='contactPageForm'>
            <div className='formBody'>
              <div className='formRow'>
                
                <div className='oneHalfSection'>
                  <input 
                    className={this.state.errorName ? 'textInput error' : 'textInput'}
                    type='text' 
                    placeholder='Full Name&#42;'
                    value={this.state.inputName}
                    onChange={::this.changeName} />
                </div>
                <div className='oneHalfSection'>
                  <input 
                    className={this.state.errorEmail ? 'textInput error' : 'textInput'}
                    type='email' 
                    placeholder='Email Address&#42;'
                    value={this.state.inputEmail}
                    onChange={::this.changeEmail} />
                </div>
              </div>
              <div className='formRow'>
                <div className='oneHalfSection'>
                  <input 
                    className={this.state.errorPhone ? 'textInput error' : 'textInput'}
                    type='text' 
                    placeholder='Telephone'
                    value={this.state.inputPhone}
                    onChange={::this.changePhone} />
                </div>
                <div className='oneHalfSection'>
                  <RhinoSelect
                    selectClass={'contactSelect contactPageSelect'}
                    required={true}
                    options={this.state.locations}
                    changeMethod={(evt) => this.changeLocation(evt)}
                    value={this.state.inputLocation}
                    error={this.state.errorLocation} />
                </div>
              </div>
              <div className='formRow'>
                <div className='textareaInputWrapper'>
                  <textarea
                    className={this.state.errorMessage ? 'textTextarea error' : 'textTextarea'}
                    placeholder='How can we help you?'
                    value={this.state.inputMessage}
                    onChange={::this.changeMessage}>
                  </textarea>
                </div>
              </div>
              <div className='repairNotice' style={{ display: this.state.selectedOption === 'service' ? 'block' : 'none' }}>Walk-ins always welcome! No appointment needed for routine jewelry cleanings.</div>
              <div className='formRow'>
                <div className={'submitButton actionButton'} onClick={::this.submitContactRequest}>Submit</div>
              </div>
            </div>
          </div>
        </div>
        <div className={this.state.selectedForm === 'shopping' ? 'sbFormWrapper openForm' : 'sbFormWrapper'}>
          <ScheduleShoppingFormContainer closeMethod={() => this.toggleForm('shopping')} />
        </div>
        <div className={this.state.selectedForm === 'service' ? 'sbFormWrapper openForm' : 'sbFormWrapper'}>
          <ScheduleServiceFormContainer closeMethod={() => this.toggleForm('service')} />
        </div>
        <div className='sbText'>We look forward to connecting with you!</div>
      </div>
      <div className='scheduleFooterSpacer'></div>
    </div>;
  }
}
export default ContactPage;

function mapStateToProps(state) {
  return {

  };
}

export const ContactPageContainer = connect(
  mapStateToProps,
  allActionCreators
)(ContactPage);


// WEBPACK FOOTER //
// ./src/components/views/contact/ContactPage.jsx